/**
 * Rótulos de exibição da origem do pedido — ESPELHA `ORIGIN_LABELS` do painel antigo do site
 * (`admin/pedidos.html`), fonte de verdade dos rótulos. Mantido em sincronia à mão porque os
 * dois repositórios são separados. Um código desconhecido (canal novo adicionado no site antes
 * daqui) cai no fallback de `rotuloOrigemPedido` — nunca quebra.
 */
export const ROTULO_ORIGEM_PEDIDO = {
    site: 'Site',
    whatsapp: 'WhatsApp',
    instagram: 'Instagram',
    facebook: 'Facebook',
    youtube: 'YouTube',
    tiktok: 'TikTok',
    partner: 'Parceiro',
    manual: 'Manual',
    other: 'Outro',
    pre_configurados: 'Pré-configurados',
    campanha_pg: 'Campanha PG',
};
/**
 * Origem do pedido pronta para exibição — MESMA regra do painel antigo do site
 * (`ORIGIN_LABELS[origin] || origin || '—'`): rótulo conhecido, senão o código cru, senão `—`
 * (pedido antigo/sem origem). Listagem e detalhe do ERP devem SEMPRE passar por aqui — nunca
 * texto fixo.
 */
export function rotuloOrigemPedido(origem) {
    if (!origem)
        return '—';
    return ROTULO_ORIGEM_PEDIDO[origem] ?? origem;
}
/**
 * Identificação COMERCIAL do pedido para exibição em qualquer tela (lista, detalhe, timeline,
 * documentos, Portal, e-mail). Antes do pagamento o pedido não tem número → "OPS PG Custom".
 * Depois do pagamento → o número real (`NFPG####`) replicado do site. O id técnico (UUID)
 * continua sendo a chave de API/URL, mas nunca é a identificação principal na interface.
 */
export function rotuloReferenciaPedido(pedido) {
    return pedido.numero ?? 'OPS PG Custom';
}
/** Ordem de exibição — mesma ordem do fluxo real de produção da PG Custom. */
export const STATUS_OPERACIONAL_PEDIDO = [
    'solicitado',
    'pedido_ao_fornecedor',
    'encaminhado_pg_lab',
    'producao',
    'montagem',
    'calibracao',
    'controle_finalizado',
    'testes_comandos',
    'enviado',
    'entregue',
];
export const ROTULO_STATUS_OPERACIONAL = {
    solicitado: 'Solicitado',
    pedido_ao_fornecedor: 'Pedido ao fornecedor',
    encaminhado_pg_lab: 'Encaminhado para PG Lab',
    producao: 'Produção',
    montagem: 'Montagem',
    calibracao: 'Calibração',
    controle_finalizado: 'Controle Finalizado',
    testes_comandos: 'Testes de Comandos',
    enviado: 'Enviado',
    entregue: 'Entregue',
};
/**
 * Mensagem PÚBLICA padrão de cada etapa operacional — usada automaticamente quando o admin
 * avança o status pelo painel novo sem escrever uma mensagem própria (`PedidoService`
 * `adicionarEvento`, na transição de status). Fonte ÚNICA: importada pelo backend (regra) e
 * pelo frontend (só para mostrar ao admin o que o cliente vai receber). Nunca contém
 * previsão/data/estimativa; nunca cobre status COMERCIAL.
 */
export const MENSAGEM_PUBLICA_PADRAO_STATUS_OPERACIONAL = {
    solicitado: 'Seu pedido foi solicitado à loja. Assim que o controle chegar, iremos encaminhá-lo para a PG Lab, onde iniciaremos o processo de modificação.',
    pedido_ao_fornecedor: 'Já estamos providenciando o controle e os componentes necessários para o seu pedido. Assim que recebermos tudo, ele seguirá para a PG Lab.',
    encaminhado_pg_lab: 'Seu controle chegou e já foi encaminhado para a PG Lab. Em breve iniciaremos o processo de modificação.',
    producao: 'Seu controle entrou em produção. Nossa equipe já iniciou o processo de modificação e personalização conforme o seu pedido.',
    montagem: 'A etapa de produção foi concluída e seu controle está agora em montagem. Estamos realizando a instalação e integração dos componentes.',
    calibracao: 'Seu controle está na etapa de calibração. Estamos realizando os ajustes necessários para garantir o funcionamento e a precisão dos componentes instalados.',
    controle_finalizado: 'A modificação do seu controle foi concluída. Agora estamos realizando as verificações finais antes da etapa de testes.',
    testes_comandos: 'Seu controle está passando pelos testes finais de comandos. Estamos verificando o funcionamento de todos os recursos antes da liberação do pedido.',
    enviado: 'Seu pedido foi enviado. A partir de agora, ele está em transporte até o endereço informado no pedido.',
    entregue: 'Seu pedido foi entregue. Esperamos que você aproveite sua experiência com a PG Custom.',
};
/**
 * Único ponto de conversão admin→cliente de um `PedidoEvento`. Toda rota do Portal do Cliente que
 * expõe eventos de pedido DEVE passar por aqui — nunca serializar `PedidoEvento` bruto para fora
 * do ERP interno (mesmo princípio de `toTimelineStep` no painel antigo: a nota interna nunca
 * atravessa essa fronteira).
 */
export function paraEventoPublico(evento) {
    return {
        statusOperacional: evento.statusOperacional,
        mensagemCliente: evento.mensagemCliente,
        criadoEm: evento.criadoEm,
    };
}
//# sourceMappingURL=pedido.js.map